var _rect, _rect2, _g, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSpecialRewardsLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 86,
    viewBox: "0 0 101 86",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 86,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    transform: "translate(-997 -197)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -24,
    width: 260,
    height: 200,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -79,
    y: -23,
    width: 258,
    height: 198,
    rx: 3,
    stroke: "#5D5CF5",
    strokeWidth: 2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.3324,
    cy: 42.841,
    rx: 38,
    ry: 53.5,
    transform: "rotate(-60 50.3324 42.841)",
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7091 31.7031H34.2916C33.6926 31.7031 33.207 32.1924 33.207 32.7959V47.7004C33.207 48.3039 33.6926 48.7932 34.2916 48.7932H65.7091C66.3081 48.7932 66.7937 48.3039 66.7937 47.7004V32.7959C66.7937 32.1924 66.3081 31.7031 65.7091 31.7031Z",
    fill: "#F2AE43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4743 32.349V37.4669C67.4768 37.8 67.3743 38.1253 67.1816 38.3959C66.9888 38.6665 66.7157 38.8684 66.4017 38.9726C64.8953 39.4522 64.3651 40.5085 62.0392 40.5085C59.0264 40.5085 59.0264 38.7419 56.0136 38.7419C53.0009 38.7419 53.0008 40.5085 49.9881 40.5085C46.9753 40.5085 46.9753 38.7419 43.9625 38.7419C40.9497 38.7419 40.9497 40.5085 37.9369 40.5085C35.617 40.5085 35.0868 39.4522 33.5744 38.9726C33.262 38.8666 32.9908 38.664 32.7993 38.3936C32.6078 38.1233 32.5058 37.799 32.5078 37.4669V32.349C32.5078 32.0876 32.6105 31.8368 32.7934 31.6514C32.9763 31.466 33.2245 31.3611 33.484 31.3594H66.4801C66.6101 31.3578 66.7391 31.3823 66.8596 31.4313C66.9802 31.4803 67.0899 31.5529 67.1824 31.645C67.2749 31.737 67.3483 31.8467 67.3984 31.9675C67.4485 32.0884 67.4743 32.2181 67.4743 32.349Z",
    fill: "#FFE5BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5791 46.5234H28.4239C27.6019 46.5234 26.9355 47.1948 26.9355 48.023V68.5007C26.9355 69.3289 27.6019 70.0002 28.4239 70.0002H71.5791C72.4011 70.0002 73.0674 69.3289 73.0674 68.5007V48.023C73.0674 47.1948 72.4011 46.5234 71.5791 46.5234Z",
    fill: "#F2AE43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.7937 41.8672H33.207V43.9556H66.7937V41.8672Z",
    fill: "#F2AE43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9999 47.4029V54.4332C74.0044 54.89 73.8643 55.3364 73.5999 55.7076C73.3355 56.0788 72.9607 56.3554 72.5297 56.4973C70.4569 57.1591 69.7278 58.6101 66.5342 58.6101C62.3946 58.6101 62.3946 56.1816 58.2611 56.1816C54.1275 56.1816 54.1275 58.6101 49.994 58.6101C45.8604 58.6101 45.8604 56.1816 41.7269 56.1816C37.5933 56.1816 37.5933 58.6101 33.4598 58.6101C30.2662 58.6101 29.5371 57.1591 27.4703 56.4973C27.0393 56.3554 26.6645 56.0788 26.4001 55.7076C26.1357 55.3364 25.9956 54.89 26.0001 54.4332V47.4029C25.9993 47.2246 26.0335 47.0479 26.1007 46.8829C26.1678 46.718 26.2667 46.568 26.3915 46.4416C26.5164 46.3153 26.6648 46.215 26.8282 46.1466C26.9916 46.0782 27.1668 46.043 27.3438 46.043H72.6562C72.8332 46.043 73.0084 46.0782 73.1718 46.1466C73.3352 46.215 73.4836 46.3153 73.6085 46.4416C73.7333 46.568 73.8322 46.718 73.8993 46.8829C73.9665 47.0479 74.0007 47.2246 73.9999 47.4029Z",
    fill: "#FFE5BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5049 24.9414H42.421C42.4865 24.9414 42.5494 24.9676 42.5957 25.0143C42.642 25.061 42.668 25.1243 42.668 25.1903V31.3585H40.2578V25.1843C40.2594 25.1193 40.2861 25.0575 40.3323 25.0122C40.3784 24.9668 40.4404 24.9414 40.5049 24.9414Z",
    fill: "#F17105"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5125 24.3155C40.9099 24.3701 39.994 23.842 40.4339 22.3181C40.8376 20.9096 41.2955 20.4179 40.8436 19.5801C42.9104 21.2253 43.1996 24.1759 41.5125 24.3155Z",
    fill: "#F2AE43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.581 24.9414H59.4972C59.5296 24.9414 59.5617 24.9479 59.5917 24.9604C59.6217 24.9729 59.6489 24.9912 59.6719 25.0143C59.6948 25.0374 59.713 25.0649 59.7254 25.0951C59.7378 25.1253 59.7442 25.1576 59.7442 25.1903V31.3585H57.334V25.1843C57.3356 25.1193 57.3623 25.0575 57.4084 25.0122C57.4546 24.9668 57.5165 24.9414 57.581 24.9414Z",
    fill: "#F17105"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.594 24.3149C57.9914 24.3695 56.7863 23.7078 57.5094 22.3175C57.9854 21.3583 58.8109 20.2109 58.365 19.373C60.4318 21.0426 60.2811 24.1753 58.594 24.3149Z",
    fill: "#F2AE43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.042 22.3555H50.9581C51.0236 22.3555 51.0865 22.3817 51.1328 22.4284C51.1791 22.4751 51.2052 22.5384 51.2052 22.6044V31.3589H48.7949V22.6044C48.7949 22.5384 48.821 22.4751 48.8673 22.4284C48.9136 22.3817 48.9765 22.3555 49.042 22.3555Z",
    fill: "#F17105"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9536 21.7354C50.5562 21.7901 51.4721 21.2619 51.0322 19.7381C50.6285 18.3296 50.1705 17.8378 50.6224 17C48.5557 18.6695 48.2664 21.5958 49.9536 21.7354Z",
    fill: "#F2AE43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -4307.5,
    y: -1876.5,
    width: 22802,
    height: 4952,
    stroke: "white",
    strokeWidth: 51
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_80",
    x: -84,
    y: -28,
    width: 268,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_80",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpecialRewardsLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/special-rewards-logo.3364c6fd.svg";
export { ForwardRef as ReactComponent };